export function setVehicleAndDriver(vehicleAndDriver) {
  return {
    type: 'SET_VEHICLE_AND_DRIVER',
    payload: { vehicleAndDriver },
  }
}

export function otherDriversLicenseAdd(file) {
  return {
    type: 'OTHER_DRIVERS_LICENSE_ADD',
    payload: {
      file,
    },
  }
}

export function otherDriversLicenseRemove(file) {
  return {
    type: 'OTHER_DRIVERS_LICENSE_REMOVE',
    payload: {
      file,
    },
    meta: {
      offline: {
        effect: {
          method: 'DELETE',
          query: {
            mock: false,
            base: '/claims/driversLicensePhoto',
          },
        },
        commit: {
          type: 'OTHER_DRIVERS_LICENSE_REMOVE_COMMIT',
        },
        rollback: {
          type: 'OTHER_DRIVERS_LICENSE_REMOVE_ROLLBACK',
        },
      },
    },
  }
}

export function clearOtherDriverLicenseFile() {
  return {
    type: 'OTHER_DRIVERS_LICENSE_CLEAR',
  }
}
